
export const scheduletext = {
    id: "Identifiant",
    name: "Nom",
    group: "Site",
    type: "Type",
    author: "Auteur",
    modifier: "Modifié par",
    lastupdate: "Dernière modification",
    changetypeconfirmationtext: "Attention, le changement de type de planning entrainera la réinitialisation des calendriers.",
    changeequipmenttypeconfirmationtext: "Attention, le changement de type d'équipement entrainera la réinitialisation des calendriers.",
    changecontroltypeconfirmationtext: "Attention, le changement de type de controle entrainera la réinitialisation des calendriers.",
    destination: "Destination",
    none: "Aucun",
    linkedcalendar: "Agenda lié",
    timebeforeevent: "Durée avant le début d'un évennement (mn)",
    timeafterevent: "Durée après la fin d'un évennement (mn)",
    dontapplyinevent: "Ne pas appliquer de valeur pendant l'évènement",
    eventvalue: "Valeur à appliquer pour l'évènement",
    outeventvalue: "Valeur à appliquer après l'évènement",
    novalue: "Ne rien faire",
    equipmenttype: "Type d'équipement",
    controltype: "Type de controle",
    description: "Description",
    concernedavobbox: "AVOB Box concernées",

}

export const eventtext = {
    name: "Nom",
    startdate: "Jour de début",
    starttime: "Heure de début",
    enddate: "Jour de fin",
    endtime: "Heure de fin",
    lightvalue: "Etat de l'éclairage",
    tempvalue: "Température de consigne (°C)",
    freevalue: "Valeur libre",
    value: "Valeur",
}

export const linkedcalendartext = {
    id: "Identifiant",
    name: "Nom",
    group: "Site",
    url: "URL",
    refreshtime: "Durée de rafraichissement",
    lastsynchronization: "Dernière synchronisation",
    lastvalue: "Dernière valeur",
}